<template>
  <div>
    <div class="calendar-range">
      <div class="pl30"
          style="margin-top: -20px;">
        <span>
          {{ $t('personCm.label.time') }}
        </span>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-date-picker v-model="chooseDateRange"
                        type="daterange"
                        :range-separator="$t('personCm.title.to')"
                        :start-placeholder="$t('personCm.title.startTime')"
                        :end-placeholder="$t('personCm.title.endTime')"
                        @change="dataChange"
                        :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="control-panel-header">
        <el-checkbox v-model="isAllChecked"
                    :disabled="checkable"
        >
          {{ $t('personCm.label.checkAll') }}
        </el-checkbox>
      </div>
      <div class="calendar-range-item"
          v-for="(dateObj,keyIndex) in dateRange"
          :key="keyIndex"
          :style="{cursor: clickable(dateObj.weekDay) ? 'default' : 'not-allowed'}">
        <div class="calendar-range-label">
          <label>{{dateObj.label}}</label>
        </div>
        <div class="calendar-range-content"
            v-for="(val, valIndex) in 48"
            :key="valIndex"
            :style="{pointerEvents: clickable(dateObj.weekDay) ? 'auto' : 'none'}">
          <div class="calendar-header">
            <div :class="{even:valIndex%8===0}">
              <span v-if="valIndex%8===0"
                    style="position: relative;top:15px;left:-8px;font-size: 18px;color:#0f79fd;">
                ●
              </span>
              <span v-if="valIndex==47"
                    style="position: relative;top:-10px;left:12px;font-size: 24px;color:#0f79fd;">
                ●
              </span>
            </div>
          </div>
          <div class="calendar-content"
              @mousemove="handleMouseMove">
            <div :class="['',handleVisible(val,dateObj.weekDay)?'visible':'',handleElementActive(val,dateObj)?'active':'',handleItemActive(val,keyIndex)?'range':'']"
                @click="handleClickStartEnd($event,val,dateObj,keyIndex)">
              <label class="start">{{handleLabelText(valIndex)}}</label>
              <label class="end"
                    v-if="handleElementActive(val,dateObj)&&val===47">24:00</label>
            </div>
          </div>
        </div>
        <div style="width: 100px;line-height: 25px;"
            class="tc">
          <div @click="handleAllDay(keyIndex,dateObj.weekDay)"
              style="color: #0079FB"
              class="pointer">
            {{$t('personCm.button.allDay')}}
          </div>
          <div @click="handleReset(keyIndex,dateObj.weekDay)"
              style="color: #fff"
              class="pointer">
            {{$t('personCm.button.reset')}}
          </div>
        </div>
      </div>
      <!--坐标轴-->
      <div class="axis-label">
        <div v-for="(item2,index2) in 48"
            class="axis-label-item"
            :class="{highmark:(index2 + 1)%8===0}"
            :key="index2">
          <div v-if="(index2 + 1)%8===0"
              style="position: relative;left:9px;top:20px;font-size: 18px;word-break: normal;">
              <span v-if="(index2+1)/2 < 10">0</span>
                {{(index2+1)/2}}
          </div>
        </div>
      </div>
    </div>
    <div class="buts"
         v-if="isNeedFooter"
         style="position: relative;top:20px;">
      <el-button type="primary"
                 class="sure-btn"
                 @click="sureData"
      >
        {{ $t('personCm.button.confirm') }}
      </el-button>
      <el-button type="info"
                 class="cancle-btn"
                 @click="closePanel"
      >
        {{$t('personCm.button.cancel')}}
      </el-button>
    </div>
  </div>
</template>

<script>
const ONEDAY = 1000 * 60 * 60 * 24
import { Dates } from '$utils'
import dayjs from 'dayjs'
export default {
  props: {
    isNeedFooter: { type: Boolean, default: false }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const a = dayjs().startOf('day')
          const day = `${a.$y}-${a.$M + 1}-${a.$D} 00:00:00`
          return (
            time.getTime() < dayjs(day).valueOf()
            // time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          )
        }
      },
      // 全选按钮可选
      checkable: true,
      // 全选按钮是否选中
      isAllChecked: false,
      startDay: 0,
      endDay: 6,
      chooseDateRange: null,
      chooseWeekRange: [], // 选中星期段
      dataRangeMsec: null,
      item: null,
      checkStart: false,
      elementWidth: 0,
      moveStart: 0,
      moveEnd: 0,
      offsetLeft: 0,
      startNumber: 0,
      endNumber: 0,
      range: [],
      rangeArr: [],
      rangeObject: {
        // temp: {start: 0, end: 6, arr: [3, 4, 5, 6]}
      },
      dateRange: [
        { label: this.$t('personCm.label.Monday'), value: '2019-05-05', weekDay: '1', dateRange: [] },
        { label: this.$t('personCm.label.Tuesday'), value: '2019-05-06', weekDay: '2', dateRange: [] },
        { label: this.$t('personCm.label.Wednesday'), value: '2019-05-07', weekDay: '3', dateRange: [] },
        { label: this.$t('personCm.label.Thursday'), value: '2019-05-08', weekDay: '4', dateRange: [] },
        { label: this.$t('personCm.label.Friday'), value: '2019-05-09', weekDay: '5', dateRange: [] },
        { label: this.$t('personCm.label.Saturday'), value: '2019-05-10', weekDay: '6', dateRange: [] },
        { label: this.$t('personCm.label.Sunday'), value: '2019-05-11', weekDay: '7', dateRange: [] }
      ],
      index: 0,
      date: '',
      weekData: this.dateRange,
      weekDataS: [0, 1, 2, 3, 4, 5, 6],
      resultObject: {},
      type: 'week'
    }
  },
  computed: {
    adjustedStartDay() {
      return (this.startDay + 6) % 7
    },
    adjustedEndDay() {
      return (this.endDay + 6) % 7
    },
    moveNumber() {
      return this.moveEnd - this.moveStart
    },
    mouseLeftMargin() {
      return this.moveStart - this.offsetLeft
    },
    dynamicRange() {
      let dynamicRange = []
      this.dateRange.forEach(function(obj) {
        dynamicRange.push({
          weekDay: obj.weekDay,
          dateRange: [],
          dateRangeStr: []
        })
      })
      return dynamicRange
    }
  },
  watch: {
    // 全选监听
    isAllChecked() {
      if (this.dataRangeMsec >= ONEDAY * 6) {
        this.setAllChecked(0, 6)
      } else if (this.adjustedStartDay < this.adjustedEndDay) {
        this.setAllChecked(this.adjustedStartDay, this.adjustedEndDay)
      } else if (this.adjustedStartDay > this.adjustedEndDay) {
        this.setAllChecked(0, this.adjustedEndDay)
        this.setAllChecked(this.adjustedStartDay, 6)
      } else {
        if (this.isAllChecked) {
          this.handleAllDay(this.adjustedStartDay, this.adjustedStartDay + 1)
        } else {
          this.handleReset(this.adjustedStartDay, this.adjustedStartDay + 1)
        }
      }
    }
  },
  beforeDestroy() {
    // console.log('########销毁', this.dateRange)
    // this.clear();
  },
  destroyed() {
    let data = this._data
    Object.keys(data).forEach(item => {
      if (data[item] instanceof Array) {
        data[item] = []
      } else {
        data[item] = null
      }
    })
    data = null
  },
  methods: {
    // 选中start 和 end之间的时间轴
    setAllChecked(start, end) {
      for (let i = start; i <= end; i++) {
        if (this.isAllChecked) {
          this.handleAllDay(i, i + 1)
        } else {
          this.handleReset(i, i + 1)
        }
      }
    },
    // 时间轴是否可点击
    clickable(weekday) {
      weekday = weekday % 7
      if (this.startDay < this.endDay) {
        return weekday > this.endDay || weekday < this.startDay ? false : true
      } else if (this.startDay > this.endDay) {
        return weekday <= this.endDay || weekday >= this.startDay ? true : false
      } else {
        return weekday === this.endDay ? true : false
      }
    },
    //根据日期选择器的值选择布控时间段
    dataChange(val) {
      this.chooseWeekRange[0] = Dates.dateChangeWeek(this.chooseDateRange[0])
      this.chooseWeekRange[1] = Dates.dateChangeWeek(this.chooseDateRange[1])
      this.changeChooseParagraph()

      this.$emit('getDate', val)
      this.clear()
      ;(this.isAllChecked = false), (this.checkable = false)
      this.resetClickableRange()
      let pickStartDate = this.chooseDateRange[0]
      let pickEndDate = this.chooseDateRange[1]
      this.startDay = pickStartDate.getDay()
      this.endDay = pickEndDate.getDay()
      this.dataRangeMsec = pickEndDate - pickStartDate
      if (this.dataRangeMsec >= ONEDAY * 6) {
        this.resetClickableRange()
      }
    },
    resetClickableRange() {
      this.startDay = 0
      this.endDay = 6
    },
    alertMsg: function(content, msg) {
      console.log(msg, content)
    },
    // 时间校验
    CompareDate() {
      return (
        new Date(this.endDate.replace(/-/g, '/')) >
        new Date(this.startDate.replace(/-/g, '/'))
      )
    },
    // 计算两个时间点相差值
    DateDiff() {
      let self = this // sDate1和sDate2是yyyy-MM-dd格式
      let aDate
      let oDate1
      let oDate2
      let iDays
      aDate = self.startDate.split('-')
      oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) // 转换为12-18-2002格式
      aDate = self.endDate.split('-')
      oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
      console.log('相差天数', iDays)
      return iDays
    },
    // 获取两个日期的区间的每一天日期
    getAllDate() {
      let self = this
      let _arr = []
      let ab = self.startDate.split('-')
      let ae = self.endDate.split('-')
      let db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      let de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      let unixDb = db.getTime()
      let unixDe = de.getTime()
      for (let k = unixDb; k <= unixDe; ) {
        let _dayStr = self.DateFormat(new Date(parseInt(k)))
        let _week = new Date(_dayStr).getDay()
        _arr.push({
          label: self.getWeekStr(_week),
          value: _dayStr,
          weekDay: _week,
          dateRange: []
        })
        k = k + 24 * 60 * 60 * 1000
      }
      self.dateRange = _arr
      self.rangeObject = {}
      console.log('模板数据', _arr)
    },
    // 时间格式转换
    DateFormat(date) {
      let s = ''
      let mouth =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : '0' + (date.getMonth() + 1)
      let day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
      s += date.getFullYear() + '-' // 获取年份。
      s += mouth + '-' // 获取月份。
      s += day // 获取日。
      return s // 返回日期。
    },
    getWeekStr(week) {
      switch (week) {
        case 0:
          return '星期日'
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
        default: {
          return ''
        }
      }
    },
    getDate(datestr) {
      let temp = datestr.split('-')
      let date = new Date(temp[0], temp[1], temp[2])
      return date
    },
    clear() {
      this.handleSelectAll = false
      for (let i = 0; i < 7; i++) {
        this.handleReset(i, i + 1)
      }
    },
    clears(timeS, timeE) {
      timeS = timeS == null ? '' : timeS
      timeE = timeE == null ? '' : timeE
      if (timeS === 7) {
        this.weekDataS = [0, 1, 2, 3, 4, 5, 6]
      } else if (timeS === 1) {
        this.weekDataS = [0]
      } else {
        timeS = timeS.replace(/-/g, '/')
        timeE = timeE.replace(/-/g, '/')
        if (
          timeS !== '' &&
          timeS !== null &&
          (timeE !== '' && timeE !== null)
        ) {
          timeS = timeS + ' 00:00:00'
          timeE = timeE + ' 23:59:59'
          let dataOrder =
            parseInt(
              timeS
                .split('-')
                .join('')
                .split(':')
                .join('')
                .split(' ')
                .join('')
            ) >
            parseInt(
              timeE
                .split('-')
                .join('')
                .split(':')
                .join('')
                .split(' ')
                .join('')
            )
          if (!dataOrder) {
            for (let i = 0; i < 7; i++) {
              this.handleReset(i, i + 1)
            }
            let times = new Date(timeS)
            let timee = new Date(timeE)
            let dataN = parseInt(
              (timee.getTime() - times.getTime()) / 1000 / 3600 / 24
            )
            let startWeek = times.getDay()
            let weekData = []
            for (var i = startWeek; i <= startWeek + dataN; i++) {
              if (weekData.length < 7) {
                let ii = i
                ii = ii > 7 ? ii - 7 : ii
                ii = ii - 1
                ii = ii === -1 ? 6 : ii
                weekData.push(ii)
              }
            }
            weekData.sort()
            this.weekDataS = weekData
          }
        } else {
          this.weekDataS = []
          for (let i = 0; i < 7; i++) {
            this.handleReset(i, i + 1)
          }
        }
      }
      this.handleSelectAll()
    },
    /**
     * @param e 点击元素
     * @param item 点击第几个元素
     * @param
     */
    handleClickStartEnd(e, item, obj, index) {
      let _index = index + 1
      if (!this.chooseDateRange) {
        this.$message.warning('选择布控日期段')
        return false
      }
      if (
        !(
          _index >= this.chooseWeekRange[0] && _index <= this.chooseWeekRange[1]
        )
      ) {
        this.$message.warning('不在布控日期段内')
        return false
      }
      let self = this
      // 获取单元格宽度
      self.elementWidth = e.target.clientWidth
      self.index = index

      // console.log('start', self.checkStart);
      if (self.checkStart) {
        if (self.endNumber >= self.startNumber) {
          if (typeof obj.dateRange !== 'undefined') {
            obj.dateRange = obj.dateRange.concat(self.range)
          } else {
            obj.dateRange = []
            obj.dateRange = obj.dateRange.concat(self.range)
          }
          if (typeof self.rangeObject[obj.weekDay] === 'undefined') {
            self.rangeObject[obj.weekDay] = []
          }

          for (let i in self.rangeObject) {
            if (obj.weekDay === i) {
              let judeg = true
              self.rangeObject[i].forEach((item, index) => {
                if (
                  item.start >= self.startNumber &&
                  item.end <= self.endNumber
                ) {
                  // 开始时间小于于上一个的开始时间，结束时间大于上一个的结束时间
                  self.rangeObject[i][index] = {
                    start: self.startNumber,
                    end: self.endNumber
                  }
                  judeg = false
                } else if (item.end === self.startNumber - 1) {
                  // 开始时间等于上一个的结束时间
                  self.rangeObject[i][index] = {
                    start: item.start,
                    end: self.endNumber
                  }
                  judeg = false
                } else if (item.start - 1 === self.endNumber) {
                  // 结束时间等于上一个的开启时间
                  self.rangeObject[i][index] = {
                    start: self.startNumber,
                    end: item.end
                  }
                  judeg = false
                } else if (
                  item.end >= self.endNumber &&
                  item.start - 1 < self.endNumber
                ) {
                  // 结束时间介于上一个时段的开始时间和结束时间之间
                  self.rangeObject[i][index] = {
                    start: self.startNumber,
                    end: item.end
                  }
                  judeg = false
                }
                if (index > 0) {
                  // 当前item与上一个item数据重复,即[2,4],[2,5]或[2,4],[2,4],适用情况，原本数据为[5,7],[9,10],新增数据为[2,11]或[2,8]
                  let currentItem = self.rangeObject[i][index]
                  let prevItem = self.rangeObject[i][index - 1]
                  if (
                    currentItem.start === prevItem.start &&
                    currentItem.end >= prevItem.end
                  ) {
                    self.rangeObject[i][index - 1] = currentItem
                    self.rangeObject[i].splice(index, 1)
                  } else if (
                    currentItem.start > prevItem.start &&
                    currentItem.start <= prevItem.end
                  ) {
                    // 当前item与上一个item数据交叉,即[2,8],[4,12]
                    self.rangeObject[i][index - 1] = {
                      start: prevItem.start,
                      end: currentItem.end
                    }
                    self.rangeObject[i].splice(index, 1)
                  } else if (
                    prevItem.start > currentItem.start &&
                    prevItem.start <= currentItem.end
                  ) {
                    // 当前item与上一个item数据交叉,即[4,12]，[2,8]
                    self.rangeObject[i][index - 1] = {
                      start: currentItem.start,
                      end: prevItem.end
                    }
                    self.rangeObject[i].splice(index, 1)
                  }
                }
              })
              if (judeg) {
                self.rangeObject[obj.weekDay].push({
                  start: self.startNumber,
                  end: self.endNumber
                })
              }
            }
          }
          self.handleChangeRangeDate()
        }
        self.range = []
        self.checkStart = false
      } else {
        if (self.weekDataS.indexOf(index) >= 0) {
          if (e.target.className.indexOf('active') !== -1) {
            self.checkStart = false
          } else {
            self.checkStart = true
            self.startNumber = item
            self.moveStart = e.clientX
            // self.offsetLeft = e.target.offsetLeft;
          }
        } else {
          if (self.weekDataS.length > 0) {
            if (self.weekDataS.length === 1) {
              let startWend = ['一', '二', '三', '四', '五', '六', '日']
              let alerttxt = '请选择'
              let nn = 0
              for (let item of this.weekDataS) {
                if (nn === 0) {
                  nn = 1
                  alerttxt += '星期' + startWend[item]
                } else {
                  alerttxt += '星期' + startWend[item]
                }
              }
              alerttxt += '的时间段'
              this.alertMsg(alerttxt, '提示')
            } else {
              let startWend = ['一', '二', '三', '四', '五', '六', '日']
              let alerttxt = '请选择'
              let nn = 0
              for (let item of this.weekDataS) {
                if (nn === 0) {
                  nn = 1
                  alerttxt += '星期' + startWend[item]
                } else {
                  alerttxt += '星期' + startWend[item]
                }
              }
              alerttxt += '的时间段'
              this.alertMsg(alerttxt, '提示')
            }
          }
        }
      }
    },
    handleMouseMove(e) {
      let self = this
      if (self.checkStart) {
        self.moveEnd = e.clientX
        let _moveValue = self.moveNumber + self.elementWidth / 3
        let _elementNum = parseFloat(_moveValue / self.elementWidth).toFixed(0)
        let limit = _elementNum - 1 + self.startNumber
        self.range = []
        self.endNumber = limit
        for (let i = self.startNumber; i <= limit; i++) {
          self.range.push(i)
        }
        // console.log('move', self.range);
      }
    },
    handleItemActive(item, index) {
      let flag = false
      if (this.index === index) {
        this.range.forEach(function(_item, index) {
          if (item === _item) {
            flag = true
            return false
          }
        })
      }
      return flag
    },
    handleElement(item, date, data) {
      console.log(data)
      let self = this
      let flag = false
      for (let obj in self.rangeObject) {
        if (self.rangeObject[obj].date === date) {
          self.rangeObject[obj].arr.forEach(function(i, index) {
            console.log(index)
            if (item === i) {
              flag = true
            }
          })
        }
      }
      return flag
    },
    handleElementActive(item, obj) {
      // console.info(obj);
      let flag = false
      if (obj.dateRange) {
        for (let i = 0; i < obj.dateRange.length; i++) {
          if (obj.dateRange[i] === item) {
            flag = true
            break
          }
        }
      }
      return flag
    },
    // 控制背景条
    handleVisible(item, key) {
      let self = this
      let flag = false
      if (typeof self.rangeObject[key] !== 'undefined') {
        let _tmpArr = self.rangeObject[key]
        for (let i = 0; i < _tmpArr.length; i++) {
          if (_tmpArr[i].start === item || _tmpArr[i].end + 1 === item) {
            flag = true
            break
          }
        }
      }
      return flag
    },
    handleLabelText(item) {
      let _labelText = ''
      let _labelNumber = (item / 2 >= 10 ? item / 2 : '0' + item / 2).toString()
      if (_labelNumber.indexOf('.') !== -1) {
        _labelText = _labelNumber.split('.')[0] + ':30'
      } else {
        _labelText = _labelNumber + ':00'
      }
      return _labelText
    },
    handleChangeRangeDate() {
      let self = this
      self.resultObject = {}
      // console.log('rangeObject', self.rangeObject);
      for (let obj in self.rangeObject) {
        let _prop = self.rangeObject[obj]
        self.resultObject[obj] = []
        for (let _item of _prop) {
          self.resultObject[obj].push({
            startTime: self.handleTimes(_item.start - 1),
            endTime: self.handleTimes(_item.end)
          })
        }
      }
      // console.log('时间控件传值', self.resultObject);
      this.$emit('change', self.resultObject)
    },
    handleTimes(number) {
      let tempStr = (number / 2).toString()
      if (tempStr.indexOf('.') !== -1) {
        let hourNumber = parseInt(tempStr.split('.')[0])
        return hourNumber < 10
          ? '0' + hourNumber + '3000'
          : hourNumber >= 24
          ? hourNumber + '0000'
          : hourNumber + '3000'
      } else {
        return tempStr < 10 ? '0' + number / 2 + '0000' : tempStr + '0000'
      }
    },
    handleReset(keyIndex, weekDay) {
      this.dateRange[keyIndex].dateRange = []
      this.rangeObject[weekDay] = []
      this.handleChangeRangeDate()
    },
    handleAllDay(keyIndex, weekDay) {
      if (!this.chooseDateRange) {
        this.$message.warning('选择布控日期段')
        return false
      }
      if (
        !(
          Number(weekDay) >= this.chooseWeekRange[0] &&
          Number(weekDay) <= this.chooseWeekRange[1]
        )
      ) {
        return false
      }
      if (this.weekDataS.indexOf(keyIndex) >= 0) {
        this.dateRange[keyIndex].dateRange = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48
        ]
        this.rangeObject[weekDay] = [{ start: 1, end: 48 }]
        this.handleChangeRangeDate()
      }
    },
    changeType(val) {
      if (val === 'day') {
        this.dateRange = [
          { label: '每天', value: '2018-02-05', weekDay: '0', dateRange: [] }
        ]
      } else {
        this.dateRange = [
          { label: '星期一', value: '2018-02-05', weekDay: '1', dateRange: [] },
          { label: '星期二', value: '2018-02-06', weekDay: '2', dateRange: [] },
          { label: '星期三', value: '2018-02-07', weekDay: '3', dateRange: [] },
          { label: '星期四', value: '2018-02-08', weekDay: '4', dateRange: [] },
          { label: '星期五', value: '2018-02-09', weekDay: '5', dateRange: [] },
          { label: '星期六', value: '2018-02-10', weekDay: '6', dateRange: [] },
          { label: '星期日', value: '2018-02-11', weekDay: '7', dateRange: [] }
        ]
      }
      this.rangeObject = {}
    },
    // 数据回填展示
    setData(_tempData, title) {
      console.log('---------------->', _tempData)
      console.log('数据回填的值', _tempData, title)
      let self = this
      // self.resultObject = {};
      // 回填标题
      this.chooseDateRange = [new Date(title[0]), new Date(title[1])]
      this.chooseWeekRange[0] = Dates.dateChangeWeek(this.chooseDateRange[0])
      this.chooseWeekRange[1] = Dates.dateChangeWeek(this.chooseDateRange[1])
      this.changeChooseParagraph()
      this.checkable = false

      if (_tempData) {
        _tempData.forEach(item => {
          // item.dayType = String(Number(item.dayType) + 1)
          if (item.dayType === '0') {
            item.dayType = '7'
          }
          if (item.endTime === '235959') {
            item.endTime = '240000'
          }
        })
        let _arr = []
        let old = ''
        for (let item of _tempData) {
          for (let range of self.dateRange) {
            if (old !== item.dayType) {
              _arr = []
            }
            if (item.dayType === range.weekDay) {
              let val = self.handleData(item.startTime, item.endTime)
              _arr = _arr.concat(val)
              range.dateRange = _arr
              old = range.weekDay
              break
            }
          }
          if (typeof self.rangeObject[item.dayType] === 'undefined') {
            self.rangeObject[item.dayType] = []
          }
          self.rangeObject[item.dayType].push(self.handleVisbleLabel(item))
          console.log('############', self.rangeObject)
        }
      } else {
        console.info('无法锁定参数')
      }

      self.handleChangeRangeDate()
      // console.info(self.dateRange)
    },
    handleData(start, end) {
      // console.log('start', start, end)
      let self = this
      let resultStr = []
      for (
        let i = self.handleDateForNumber(start) + 1;
        i <= self.handleDateForNumber(end);
        i++
      ) {
        resultStr.push(i)
      }
      return resultStr
    },
    handleDateForNumber(str) {
      let _Hour = parseInt(str.substring(0, 2))
      let _Min = parseInt(str.substring(2, 4))
      // console.log('#######_Hour', _Hour);
      // console.log('#######_Min', _Min);
      // _Hour = _Hour * 2;
      _Hour *= 2
      if (_Min >= 30) {
        _Hour += 1
      }
      console.log('_Hour', _Hour)
      return _Hour
    },
    handleVisbleLabel(arr) {
      let self = this
      let result = {
        start: self.handleDateForNumber(arr.startTime) + 1,
        end: self.handleDateForNumber(arr.endTime)
      }
      return result
    },
    closePanel() {
      this.$emit('close')
    },
    /*
     *@name:日期范围面板确定回调处理
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-05-08 22:23:17
     */
    sureData() {
      if (!this.chooseDateRange) {
        this.$message.warning(this.$t('personCm.message.controlDate'))
        return false
      }
      let or = true
      let resultObject = {}
      for (let i in this.resultObject) {
        if (i !== 'undefined') {
          resultObject[i] = this.resultObject[i]
        }
      }
      this.resultObject = resultObject
      for (let i in this.resultObject) {
        this.resultObject[i].length > 0 && (or = false)
      }
      if (or) {
        this.$message.warning(this.$t('personCm.message.controlTime'))
        return false
      }
      let newArry = {}
      for (let i in this.resultObject) {
        if (+i === 7) {
          i = 0
        }
        newArry[i] = []
        this.resultObject[i === 0 ? 7 : i].forEach(item => {
          if (item.endTime === '240000') {
            item.endTime = '235959'
          }
          newArry[i].push({
            startTime: item.startTime,
            endTime: item.endTime
          })
        })
      }
      this.$emit('getDate', {
        dates: this.chooseDateRange,
        resData: newArry
      })
      this.closePanel()
    },
    /*
     *@name: 转换成可以选择的星期段
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-05-09 11:28:23
     */
    changeChooseParagraph() {
      let data = this.chooseWeekRange
      let startDate = {
        y: Dates.format(this.chooseDateRange[0], 'yyyy'),
        m: Dates.format(this.chooseDateRange[0], 'MM'),
        d: Dates.format(this.chooseDateRange[0], 'dd')
      }
      let endDate = {
        y: Dates.format(this.chooseDateRange[1], 'yyyy'),
        m: Dates.format(this.chooseDateRange[1], 'MM'),
        d: Dates.format(this.chooseDateRange[1], 'dd')
      }
      if (Number(endDate.y) > Number(startDate.y)) {
        this.chooseWeekRange = [1, 7]
        return false
      }
      if (Number(endDate.m) > Number(startDate.m)) {
        this.chooseWeekRange = [1, 7]
        return false
      }
      if (Number(endDate.d) - Number(startDate.d) >= 7) {
        this.chooseWeekRange = [1, 7]
        return false
      }
      if (data[1] < data[0]) {
        this.chooseWeekRange = [1, 7]
      } else if (data[1] === data[0]) {
        if (
          Dates.format(this.chooseDateRange[0], 'yyyy-MM-dd') ===
          Dates.format(this.chooseDateRange[1], 'yyyy-MM-dd')
        ) {
          return false
        } else {
          this.chooseWeekRange = [1, 7]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.axis-label {
  position: absolute;
  width: calc(100% - 180px);
  height: 10px;
  left: 80px;
  bottom: 20px;
  display: flex;
  &-item {
    flex: 1;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    height: 5px;
  }
  .highmark {
    flex: 1;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    height: 15px;
    margin-top: -10px;
  }
}
.buts {
  text-align: center;
  padding-bottom: 10px;
}
.el-button:not(.el-button--text) {
  min-width: 50px;
}
.cancle-btn {
  width: 100px;
}

.sure-btn {
  width: 100px;
}
.calendar-range {
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: column;
  position: relative;
  .pl30 .el-date-editor { width: 510px;}
}

.calendar-range:after {
  content: '';
  position: relative;
  width: 85%;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.2);
  left: 80px;
  // top: -40px;
  margin-bottom: 20px;
}
.calendar-range .control-panel-header {
  padding: 20px 30px;
}
.calendar-range .calendar-range-item {
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: row;
  // padding-bottom: 20px;
}

.calendar-range .calendar-range-item:before {
  content: '';
  position: absolute;
  width: 3px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.2);
  left: 80px;
}

.calendar-range .calendar-range-item .calendar-range-label {
  width: 80px;
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 25px;
  color: #fff;
  font-size: 14px;
}

.calendar-range .calendar-range-item .calendar-range-content {
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  height: 60px;
}

.calendar-range .calendar-range-item .calendar-range-content .calendar-header {
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: row;
  height: 30px;
  align-items: flex-end;
  border-bottom: rgba(255, 255, 255, 0.2) solid 1px;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-header
  > div {
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  /*border-left: rgba(255,255,255, .2) solid 1px;*/
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  height: 5px;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-header
  > div.even {
  height: 30px;
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: row;
  align-items: center;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-header
  > div.even
  > span {
  padding-left: 2px;
  font-size: 12px;
  color: #6e767c;
  font-size: 14px;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-header
  > div:first-child {
  border-left: none;
}

.calendar-range .calendar-range-item .calendar-range-content .calendar-content {
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  flex-direction: row;
  height: 30px;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div {
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  border-left: rgba(#000, 0.2) solid 1px;
  cursor: pointer;
  position: relative;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div
  > label.start {
  position: absolute;
  bottom: 50px;
  left: -20px;
  background-color: #0f79fd;
  color: #fff;
  z-index: 11;
  visibility: hidden;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 12px;
  line-height: 10px;
  min-width: 40px;
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    border-right: 5px solid transparent;
    border-top: 5px solid #0f79fd;
    border-left: 5px solid transparent;
    position: absolute;
    top: 14px;
    left: 15px;
  }
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div
  > label.end {
  position: absolute;
  bottom: 50px;
  right: -40px;
  background-color: #0f79fd;
  color: #fff;
  z-index: 11;
  visibility: visible;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 12px;
  line-height: 10px;
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    border-right: 5px solid transparent;
    border-top: 5px solid #0f79fd;
    border-left: 5px solid transparent;
    position: absolute;
    top: 14px;
    left: 15px;
  }
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div.visible
  > label {
  visibility: visible;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div:hover
  > label {
  visibility: visible;
  z-index: 10;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div.active {
  background-color: transparent;
  border-top: 5px solid #0775ff;
  margin-top: -3px;
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div.range {
  background-color: transparent;
  /*border-color: rgba(255,255,255, 0.6);*/
  border-top: 2px solid rgba(255, 255, 255, 0.6);
}

.calendar-range
  .calendar-range-item
  .calendar-range-content
  .calendar-content
  > div:first-child {
  border-left: none;
}
.calendar-range .cr-rest {
  background: rgba(0, 0, 0, 0);
  border: 1px solid #323942;
  border-color: #006ae2;
  color: #9da5bb;
}
</style>
